<style lang="scss">
	.workshop_alert_tabs {
		.el-tabs__header {
			margin: 0;
			border-bottom: 1px solid #606672;
		}

		.el-tabs__header .el-tabs__nav {
			border-radius: 0;
			border: 1px solid #606672;
			border-bottom: none;
		}

		.el-tabs__header .el-tabs__item {
			border-left: 1px solid #606672;
			border-bottom: none;
		}

		.el-tabs__header .el-tabs__item.is-active {
			background: #202027;
		}
	}

	.tab_content {
		border: 1px solid #606672;
		border-top: none;
	}

	.equipmentAlertTable .el-progress-bar__outer {
		background: #606672;
	}

	.equipmentAlertTable .el-progress__text {
		color: #FFFFFF;
	}


	.equipmentAlertTable::before {
		z-index: inherit;
	}

	.equipmentAlertTable.el-table--enable-row-hover .el-table__body tr:hover>td {

		background-color: #33333A !important;

	}

	.equipmentAlertTable.el-table {
		background-color: transparent;
	}

	.equipmentAlertTable.el-table--border:after,
	.equipmentAlertTable.el-table--group:after,
	.equipmentAlertTable.el-table:before {
		background-color: transparent;
	}

	.equipmentAlertTable.el-table tr {
		background-color: transparent;
	}

	.equipmentAlertTable .el-table td.gutter,
	.equipmentAlertTable.el-table th.gutter {
		background: #33333A;
	}

	.equipmentAlertTable .el-table__body-wrapper {
		background: #1D1D24;
	}

	// 滚动条的宽度
	.equipmentAlertTable .el-table__body-wrapper::-webkit-scrollbar {
		width: 2px; // 横向滚动条
	}
	// 滚动条的滑块
	.equipmentAlertTable .el-table__body-wrapper::-webkit-scrollbar-thumb {
		background-color: #419FFF;
		border-radius: 2px;
	}
	.workshop_alert_tabs {
		.el-pagination__total{
			color: #C0C4CC;
		}
		.el-pagination.is-background .el-pager li{
			color: #C0C4CC;
			background: rgba(133, 138, 147, 0.2);
		}
		.el-pagination.is-background .el-pager li:not(.disabled).active{
			color: #419FFF;
			background: rgba(65, 159, 255, 0.2);
		}
		.el-pagination.is-background .btn-next{
			color: #C0C4CC;
			background: rgba(133, 138, 147, 0.2);
		}
		.el-pagination.is-background .btn-prev{
			color: #C0C4CC;
			background: rgba(133, 138, 147, 0.2);
		}

	}
	.workshop_alert_tabs.number{color: red;}
</style>
<style lang="scss" scoped="scoped">
.container::-webkit-scrollbar {
		display: none;
	}
</style>

<template>
	<div ref="container" class="workshop_alert_tabs" style="overflow: auto;height: 100%;position: relative">
		<div ref="tabs">
			<el-tabs v-model="activeName" type="card" @tab-click="handleClick">
				<el-tab-pane :label="$t('zhushebei')" :name="equipment.id+''"></el-tab-pane>
				<el-tab-pane v-for="(device,index) in tabsData.devices" :label="$t(device.device.name)"
					:name="device.device.id+''">
				</el-tab-pane>
			</el-tabs>
		</div>

		<div style="border:1px solid #606672; border-top: none;padding: 14px;"
			:style="{'height':alertHeight+'px'}">
			<div>
				<el-table class="equipmentAlertTable" :data="alerts" style="width: 100%" :max-height="alertHeight-paginationHeight-30"
					:row-style="{background:'#1D1D24',height:rowHeight+'px'}"
					:cell-style="{padding:0+'px',borderColor:'#202027',color:'#FFFFFF','font-size':'14px'}"
					:header-cell-style="{background:'#33333A',color:'#C0C4CC',padding:'0px', height:'34px',borderColor:'#202027'}">
					<el-table-column :label="$t('baojingxinxi')">
						<template slot-scope="scope">
							{{$t(scope.row.i18n)}}
						</template>
					</el-table-column>
					<el-table-column prop="equipmentStatus" :label="$t('zhuangtai')">
						<template slot-scope="scope">
							<div style="line-height: 28px;">
								<span v-if="scope.row.flag==1"
									style="color:#F4F4F4;background:#C6164B;border-radius: 12px;font-size: 10px;padding: 3px 8px;box-sizing: border-box;">{{$t('jinxingzhong')}}</span>
							<span v-if="scope.row.flag==2"
									style="color:#F4F4F4;background:#292F3E;border-radius: 12px;font-size: 10px;padding: 3px 8px;box-sizing: border-box;">{{$t('yijieshu')}}</span>

							</div>

						</template>
					</el-table-column>
					<el-table-column :label="$t('kaishishijian')">
						<template slot-scope="scope">
							{{dayjs.unix(scope.row.begin/1000).format('MM-DD HH:mm')}}
						</template>
					</el-table-column>
					<el-table-column :label="$t('jieshushijian')">
						<template slot-scope="scope">
							{{scope.row.end?(dayjs.unix(scope.row.end/1000).format('MM-DD HH:mm')):''}}
						</template>
					</el-table-column>
					<el-table-column :label="$t('chixushijian')+'(min)'">
						<template slot-scope="scope">
							{{scope.row.end?((scope.row.end-scope.row.begin)/1000/60).toFixed(1):''}}
						</template>
					</el-table-column>

					<el-table-column prop="equipmentStatus" :label="$t('baojingleixing')">
						<template slot-scope="scope">

							<div style="line-height: 28px;">
								<span v-if="scope.row.level==1"
									style="color:#FFC83A;border: 1px solid #FFC83A;background: rgba(255, 200, 58, 0.2);border-radius: 2px;font-size: 10px;padding: 3px 8px;box-sizing: border-box;">{{$t('gaojing')}}</span>
								<span v-if="scope.row.level==2"
									style="color:#FF3A5E;border: 1px solid #FF3A5E;background: rgba(255, 58, 94, 0.2);border-radius: 2px;font-size: 10px;padding: 3px 8px;box-sizing: border-box;">{{$t('guzhang')}}</span>
								</div>
						</template>
					</el-table-column>
				</el-table>

			</div>
			<!-- <div ref="pagination" style="padding-top: 10px;width: 100%;display: flex;justify-content: flex-end;">
				<el-pagination background layout="total,prev, pager, next" @current-change="pageEquipmentAlarm"
					  :current-page.sycn="pageNum"
					:total="total" :page-size.sycn="pageSize"></el-pagination>
			</div> -->
		</div>

	</div>
</template>
<script type="text/javascript">
	export default {
		name: 'web_monitor_equipment_statistics_tabs_alert',
		components: {

		},
		props: {
			equipment: {
				type: Object,
				default: function() {
					return {}
				},
			},
			tabsData: {
				type: Object,
				default: function() {
					return {}
				},
			},
		},
		watch: {
			"equipment.id"(newValue, oldValue) {
				setTimeout(()=>{
					this.activeName = this.equipment.id + ''
					this.pageEquipmentAlarm()
				},0)
			}
		},
		data() {
			return {
				chart: null,
				options: null,
				alertHeight: 600,
				paginationHeight:0,
				rowHeight: 34,
				pageSize:10,
				pageNum:1,
				total:0,
				alerts: [],
				activeName: "",
			};
		},
		created() {
			this.activeName = this.equipment.id + ''
		},
		mounted() {
			this.pageEquipmentAlarm()
			this.resize()
			this.utils.event_hub.$on('RESIZE', () => {
				this.resize();
			});
		},
		updated() {
			console.log(0)
			this.resize()
		},

		methods: {
			handleClick(tab, event) {
				console.log('tabbbb',tab)
				this.pageEquipmentAlarm()

			},

			resize() {
				//因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
				setTimeout(() => {
					if (!this.$refs.tabs) {
						return
					}
					this.alertHeight = this.$refs.container.offsetHeight - this.$refs.tabs.offsetHeight
					// this.paginationHeight = this.$refs.pagination.offsetHeight
					// this.rowHeight = (this.alertHeight-this.paginationHeight - 28 - 34 - 4) / 10
					this.rowHeight = (this.alertHeight - 28 - 34 - 4) / 10
				}, 500)
			},

			async pageEquipmentAlarm(pageNum) {
				console.log(pageNum)
				if(pageNum==null){
					this.pageNum = 1
				}else{
					this.pageNum = pageNum
				}
				let response = await this.http.get('/web/equipment/pageEquipmentAlarm', {
					params: {
						pageNum: this.pageNum,
						pageSize: this.pageSize,
						equipmentId: this.activeName
					}
				})
				this.alerts = response.data.rows
				this.total =  response.data.total

			},
		}
	};
</script>
